{
  "actions": "Eylemler"
}
